

export const getOpenButtonAction = (itemType, item) => {
  if (itemType === 'Comment Bank' || itemType === 'commentBank') {
    return `/tools/commentbanks/${item.id}`;
  }
  if (itemType === 'Success Criterias' || itemType === 'successCriteria') {
    return `/tools/successcriterias/${item.id}`;
  }
  if (itemType === 'Short Answers' || itemType === 'shortAnswer') {
    return `/tools/shortanswers/${item.id}`;
  }
  return `/tools/rubrics/${item.id}`;
};

export const isNonSystemItem = (item) => {
  return item && !item.isSystem;
};

export const shouldShowButton = (onClone) => {
  return !!onClone;
};
